<template>
  <div class="row bg-white board-radius">
    <div class="col-12 col-md-3">
      <label class="name-title">
        Leyenda de Tipo de Disponibilidad:
      </label>
    </div>
    <div class="col-12 col-md-9 d-flex flex-wrap pr-2">
      <div class="content-container px-0">
        <div class="container-box grupal" />
        <div class="container-label">
          <span>Estudiante</span>
          <span>Modalidad Grupal</span>
        </div>
      </div>
      <div class="content-container px-0">
        <div class="container-box individual" />
        <div class="container-label">
          <span>Estudiante</span>
          <span>Modalidad Individual</span>
        </div>
      </div>
      <div class="content-container px-0">
        <div class="container-box available-space" />
        <div class="container-label">
          <span>Espacio Disponible</span>
        </div>
      </div>
      <div class="content-container px-0">
        <div class="container-box not-available-space" />
        <div class="container-label">
          <span>Espacio No Disponible</span>
        </div>
      </div>
      <div class="content-container px-0">
        <div class="container-box grupal-inside" />
        <div class="container-label">
          <span>Horario Reservado Grupal</span>
          <span>dentro de la Corporaci&oacute;n</span>
        </div>
      </div>
      <div class="content-container px-0">
        <div class="container-box individual-inside" />
        <div class="container-label">
          <span>Horario Reservado Individual</span>
          <span>dentro de la Corporaci&oacute;n</span>
        </div>
      </div>
      <div class="content-container px-0">
        <div class="container-box busy-outside" />
        <div class="container-label">
          <span>Horario Ocupado</span>
          <span>Fuera de Corporaci&oacute;n</span>
        </div>
      </div>
      <div class="content-container px-0">
        <div class="container-box expired-license">
          <i
            class="fa fa-calendar-exclamation specialist-license-expired-icon"
          />
        </div>
        <div class="container-label">
          <span>Especialista con Licencia</span>
          <span>Vencida</span>
        </div>
      </div>
      <div class="content-container px-0">
        <div class="container-box changeInService" />
        <div class="container-label">
          <span>Estudiante</span>
          <span>con Cambio en Servicio</span>
        </div>
      </div>
      <div class="content-container px-0">
        <div class="container-box practitioner" />
        <div class="container-label">
          <span>Estudiante</span>
          <span>con practicante/interno</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpecialistLegend',
};
</script>

<style lang="scss" scoped>
@import '@/scss/availability_calendar_colors.scss';

.name-title {
  color: #3f5b60;
  font-weight: 700;
  font-size: 16px;
  margin: 5px;
  padding-top: 10px;
}
.content-container {
  background-color: $calendar-accent;
  border-radius: 4px;
  opacity: 1;
  margin: 6px;
  display: flex;
  width: 290px;
  height: 50px;
}
.container-box {
  width: 32px;
  height: 32px;
  margin-top: 7px;
  margin-left: 25px;
}
.grupal {
  background-color: $student-group-modality-background;
  border-left: 4px solid $student-group-modality-accent;
}
.individual {
  background-color: $student-individual-modality-background;
  border-left: 4px solid $student-individual-modality-accent;
}
.changeInService {
  background-color: $student-change-service-background;
  border-left: 4px solid $student-change-service-accent;
}
.available-space {
  background-color: #ffffff;
  border: 2px solid #f6f6f6;
}
.not-available-space {
  background-color: transparent;
  border: 2px solid gray;
  border-radius: 4px;
}
.grupal-inside {
  background-color: $student-group-modality-background;
  border: 3px dashed $student-group-modality-accent;
}
.individual-inside {
  background-color: $student-individual-modality-background;
  border: 3px dashed $student-individual-modality-accent;
}
.busy-outside {
  background-color: $hour-out-corporation-background;
  border: 3px dashed $hour-out-corporation-accent;
}
.practitioner {
  background-color: $student-practitioner-background;
  border-left: 4px solid $student-practitioner-accent;
}
.expired-license {
  border: 2px solid #f05863;
  background-color: #fcd9d8;
  border-radius: 4px;
}
.container-label {
  flex-direction: column;
  justify-content: center;
  display: flex;
  font-size: 12px;
  padding-left: 10px;
}
.specialist-license-expired-icon {
  color: #f05863;
  padding-top: 5px;
  padding-left: 7px;
}
</style>
